import { ConfigurableProduct } from '@magentoTypes'

type FilterInput = {
  product: ConfigurableProduct
  currentForm: number | null | undefined
}

export const filteringByForm = ({ product, currentForm }: FilterInput) => {
  if (!product || !currentForm) return
  const filteredProducts = product?.related_products?.filter(
    (item) => item?.benuta_form_new === currentForm,
  )
  if (product?.benuta_form_new === currentForm) {
    filteredProducts?.unshift(product)
  }
  return filteredProducts
}
